import InputStyleHover from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/inputStyleHover.mdx";
import InputStyleFocus from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/inputStyleFocus.mdx";
import InputStylePlaceholder from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/inputStylePlaceholder.mdx";
import InputStyleWebkitAutofill from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/inputStyleWebkitAutofill.mdx";
import InputStyleSelection from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/inputStyleSelection.mdx";
import TextStyle from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/textStyle.mdx";
import BlockStyle from "../../../../content/sdk/web/2.x.x/checkout-style/_checkout-style/blockStyle.mdx";
import * as React from 'react';
export default {
  InputStyleHover,
  InputStyleFocus,
  InputStylePlaceholder,
  InputStyleWebkitAutofill,
  InputStyleSelection,
  TextStyle,
  BlockStyle,
  React
};